import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { pushSupported, getPushStatus, enablePush } from "../lib/push";

const DISMISS_KEY = "ginius_push_prompt_dismissed";

export function PushPrompt() {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) return;
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    getPushStatus().then((s) => { if (s === "default") setShow(true); });
  }, []);

  const attiva = async () => {
    setBusy(true);
    try {
      await enablePush();
      toast.success("Avvisi attivati! Riceverai una notifica sul telefono per ogni nuova manutenzione o avviso.");
      localStorage.setItem(DISMISS_KEY, "1");
      setShow(false);
    } catch (e) {
      toast.error(e.message || "Impossibile attivare le notifiche");
    } finally { setBusy(false); }
  };

  const nonOra = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };

  if (!show) return null;

  return (
    <div data-testid="push-prompt-banner"
      className="mb-4 rounded-xl border-2 border-brand/30 bg-[#FBEEF3] px-4 py-3 flex flex-wrap items-center gap-x-4 gap-y-2">
      <span className="flex items-center gap-2 font-bold text-brand">
        <BellRing className="w-5 h-5" /> Avvisi sul telefono
      </span>
      <span className="text-sm text-slate-700 min-w-0">
        Attiva le notifiche per essere avvisato sul cellulare a ogni nuova manutenzione o avviso, senza dover aprire l'app.
      </span>
      <div className="ml-auto flex items-center gap-2">
        <Button data-testid="push-prompt-enable" onClick={attiva} disabled={busy}
          className="h-9 px-4 text-sm font-bold bg-brand hover:bg-brand-dark">
          <BellRing className="w-4 h-4 mr-1.5" /> {busy ? "Attendere..." : "Attiva"}
        </Button>
        <button data-testid="push-prompt-dismiss" onClick={nonOra} aria-label="Non ora"
          className="p-2 rounded-lg text-slate-500 hover:bg-white/60 transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
